/**
 * The resume, login and admin pages each bring their own global stylesheet
 * (and the admin panel its template scripts), so two of them must never share
 * one page load. When the SPA switches from one to another (e.g. browser back
 * button) the page is reloaded so it starts clean.
 */
export type PageKind = "resume" | "login" | "admin";

let current: PageKind | null = null;

/** Registers the page; reloads and returns false if a different page was rendered before. */
export function enterPage(kind: PageKind): boolean {
  if (current && current !== kind) {
    window.location.reload();
    return false;
  }
  current = kind;
  return true;
}

/** true when the resume or login page was already rendered in this page load. */
export const publicPageShown = () => current === "resume" || current === "login";
